module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e7e7cdeac62aa40f71af104718bc95f1.png";